import {useContext} from 'react';
import EventArrowIconV4 from './EventArrowIconV4';
import EventRowItemV4 from './EventRowItemV4';
import ModuleSectionV4 from './ModuleSectionV4';
import EllipsisText from '../../common/component/EllipsisText';
import {showAuthModal} from '../../common/function';
import useLogin from '../../common/hook/useLogin';
import {routeTo} from '../../common/util/PageRouter';
import {IsUnionModuleContext} from '../common';
import useEventPageEvent from '../hook/useEventPageEvent';
import {IButtonModuleV4} from '../type';

interface IProps {
  data: IButtonModuleV4;
}

export default function ButtonModuleV4({data}: IProps) {
  const isUnionModule = useContext(IsUnionModuleContext);
  const {isLogin} = useLogin();
  const {section, buttonLabel, landingUrl} = data;

  const sendEventPageEvent = useEventPageEvent();
  const handleClick = () => {
    sendEventPageEvent({
      actionName: 'event_landing',
      customProps: {
        event_layer: isUnionModule ? 'union' : 'common',
        button_title: buttonLabel,
      },
    });
    isLogin && routeTo(landingUrl, {isShallow: false});
    !isLogin && showAuthModal({isSaveReturnPage: true});
  };

  return (
    <ModuleSectionV4 data-module-type={data.moduleType} section={section}>
      <EventRowItemV4
        isRound
        className="bg-white gap-x-10 cursor-pointer"
        leftElementClassName="flex-auto"
        leftElement={
          <EllipsisText
            line={2}
            className="s15-bold-black leading-19 tracking-[-0.4px]"
          >
            {buttonLabel}
          </EllipsisText>
        }
        rightElementClassName="flex-shrink-0"
        rightElement={<EventArrowIconV4 />}
        onClick={handleClick}
      />
    </ModuleSectionV4>
  );
}
